export default __webpack_public_path__ + "static/media/Icon-subscription-end -date-new.e332e51f.svg";